module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('span', [_vm._v("“Apri gli occhi e riguarda qual son io.”")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_vm._v("“II Paradiso” (xxiii, 46),")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("Dante’s Commedia")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d58464e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/franmatter01.vue
// module id = 72
// module chunks = 0